import {
  Component,
  EnvironmentInjector,
  inject,
  Injector,
  OnInit,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';
import { IconService } from '@services/icon.service';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { NavigationComponent } from '@components/navigation/navigation.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';

import {
  ComponentPortalService,
  ConfigService,
  LibraryInjector,
  ngxMatDateFormats,
} from '@tiltgroup/web-components';
import { environment } from '@environments/environment';
import { MatDrawer, MatSidenavModule } from '@angular/material/sidenav';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DATE_FORMATS } from '@angular/material/core';

@Component({
  selector: 'lt-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [
    RouterOutlet,
    MatIconModule,
    MatCheckboxModule,
    NavigationComponent,
    MatDialogModule,
    MatSnackBarModule,
    RouterModule,
    MatSidenavModule,
    MatButtonModule,
  ],
  // Keeps pre-Angular 22 (Default) change detection, which this component was written for.
  // TODO: migrate to OnPush.
  // eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [{ provide: MAT_DATE_FORMATS, useValue: ngxMatDateFormats }],
})
export class AppComponent implements OnInit {
  static injector: Injector;
  private _iconService = inject(IconService);
  private _injector = inject(EnvironmentInjector);

  private _configService = inject(ConfigService);
  private _componentPortalService = inject(ComponentPortalService);

  @ViewChild('drawer', { static: true })
  drawer!: MatDrawer;

  constructor() {
    AppComponent.injector = this._injector;
    LibraryInjector.setInjector(this._injector);
    this._configService.setUpEnvironment(environment);
  }

  ngOnInit() {
    this._componentPortalService.initializeDrawerRef(this.drawer);
  }
}
